module.exports = __webpack_public_path__ + "img/trophy.1dfc40a6.png";